export const manifest = {
  screens: {
    scr_r4z34a: { name: "Marketing Home", route: "/", position: {"x":160,"y":220} },
    scr_6zbqab: { name: "Portal Home", route: "/portal", position: {"x":1560,"y":220} },
    scr_y2uwfz: { name: "Quick Pay – Enter Reference", route: "/portal/quick-pay", state: {"step":1}, position: {"x":160,"y":2200} },
    scr_xzkqx2: { name: "Quick Pay – Confirm & Pay", route: "/portal/quick-pay", state: {"step":2,"reference":"REF-284910","email":"jane@example.com","amount":450}, position: {"x":1560,"y":2200} },
    scr_3ltxlg: { name: "Quick Pay – Success", route: "/portal/quick-pay", state: {"step":3,"reference":"REF-284910","email":"jane@example.com","amount":450,"confirmationNumber":"CRG-X7M2-9P4K"}, position: {"x":2960,"y":2200} },
    scr_d3fyyt: { name: "Sign In", route: "/portal/sign-in", state: {"stage":"sign-in"}, position: {"x":160,"y":4180} },
    scr_ln71vr: { name: "Email Verification", route: "/portal/sign-in", state: {"stage":"verify","email":"jane@example.com"}, position: {"x":1560,"y":4180} },
    scr_cmq55c: { name: "Account Dashboard", route: "/portal/sign-in", state: {"stage":"dashboard","email":"jane@example.com"}, position: {"x":2960,"y":4180} },
    scr_662vjr: { name: "Login Pay – Review", route: "/portal/sign-in", state: {"stage":"confirm","email":"jane@example.com","paymentData":{"paymentType":"full","fullAmount":854.7,"monthlyAmount":75,"paymentDay":1,"planMonths":12,"planEndsLabel":"12 monthly payments ending June 2027","method":"card","cardLast4":"3456","routingLast4":""}}, position: {"x":160,"y":6160} },
    scr_4j0la7: { name: "Login Pay – Success", route: "/portal/sign-in", state: {"stage":"confirm","email":"jane@example.com","paymentData":{"paymentType":"full","fullAmount":854.7,"monthlyAmount":75,"paymentDay":1,"planMonths":12,"planEndsLabel":"12 monthly payments ending June 2027","method":"card","cardLast4":"3456","routingLast4":""},"isConfirmed":true,"confirmationNumber":"CRG-B3N9-7K2P"}, position: {"x":1560,"y":6160} },
    scr_4w0ynm: { name: "Admin – Dashboard", route: "/portal/admin", position: {"x":143.99,"y":8103.92} },
    scr_c650ge: { name: "Admin – Consumers", route: "/portal/admin/consumers", position: {"x":1543.99,"y":8103.92} },
    scr_kzu7fb: { name: "Admin – Payments", route: "/portal/admin/payments", position: {"x":2943.99,"y":8103.92} },
    scr_dft65f: { name: "Admin – Offers & Plans", route: "/portal/admin/offers", position: {"x":4343.99,"y":8103.92} },
    scr_jcgq24: { name: "Admin – Communications", route: "/portal/admin/communications", position: {"x":5743.99,"y":8103.92} },
  },
  sections: {
    sec_vw5u7v: { name: "Entry Points", x: 0, y: 0, width: 2920, height: 1180 },
    sec_msvfzz: { name: "Quick Pay Flow", x: 0, y: 1980, width: 5720, height: 1180 },
    sec_gh6zvy: { name: "Login Flow", x: 0, y: 3960, width: 4320, height: 1180 },
    sec_zpmhg2: { name: "Login Pay Flow", x: 0, y: 5940, width: 2920, height: 1180 },
    sec_umywjf: { name: "Admin Console", x: -16.01, y: 7883.92, width: 7120, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_vw5u7v", children: [
      { kind: "screen", id: "scr_r4z34a" },
      { kind: "screen", id: "scr_6zbqab" },
    ] },
    { kind: "section", id: "sec_msvfzz", children: [
      { kind: "screen", id: "scr_y2uwfz" },
      { kind: "screen", id: "scr_xzkqx2" },
      { kind: "screen", id: "scr_3ltxlg" },
    ] },
    { kind: "section", id: "sec_gh6zvy", children: [
      { kind: "screen", id: "scr_d3fyyt" },
      { kind: "screen", id: "scr_ln71vr" },
      { kind: "screen", id: "scr_cmq55c" },
    ] },
    { kind: "section", id: "sec_zpmhg2", children: [
      { kind: "screen", id: "scr_662vjr" },
      { kind: "screen", id: "scr_4j0la7" },
    ] },
    { kind: "section", id: "sec_umywjf", children: [
      { kind: "screen", id: "scr_4w0ynm" },
      { kind: "screen", id: "scr_c650ge" },
      { kind: "screen", id: "scr_kzu7fb" },
      { kind: "screen", id: "scr_dft65f" },
      { kind: "screen", id: "scr_jcgq24" },
    ] },
  ],
}
